import React from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';
import { Stack } from '@mui/material';

import { Notifications, STATUS } from './Notifications';
import { MasterPageHeader } from '../components/PageHeader';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import { FieldsExpiredUsageModal } from '../components/modals/FieldsExpiredUsageModal';
import { UserAccessExpiredModal } from '../components/modals/UserAccessExpiredModal';
import { Modal } from '../components/Modal';
import TransmissionErrorResult from '../components/modals/TransmissionErrorResult';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { Information } from '../components/modals/common/';
import { messageUtility } from '../utilities/messageUtility';
import { MANUAL_CONTACT_TAB, LIST_NOTICES_TYPES } from '../utilities/constants';
import DropdownSelector from '../components/dropdowns/DropdownSelector';
import { SearchFormElement } from '../components/forms/SearchFormElement';

/**
 * 通知一覧画面
 */
export class Notices extends Notifications {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      dataList,
      isLoading,
      selectedNotice,
      modalState,
      transmissionErrorResultDialogOpened,
      visibleFieldsExpiredUsageModal,
      visibleUserAccessExpiredModal,
      visibleNoUserAccessInfo,
      total,
      isSearchFormOpen,
    } = this.state;

    return (
      <div className='master-slide-view show Notices'>
        <Helmet>
          <title>通知一覧</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader
            title='通知一覧'
            onClose={() => _masterSlideLoader.close()}
          />
          <div id='infinityscroll-target' className='master-slide-view__table'>
            <div className='notification-header'>
              <button
                className='btn--sub'
                style={{ marginRight: 'auto' }}
                onClick={() => {
                  _masterSlideLoader.show('ManualContact', {
                    state: { id: MANUAL_CONTACT_TAB.NOTICE.ID },
                  });
                }}
              >
                Buildeeからのお知らせ
              </button>
            </div>
            <SearchForm
              total={total}
              isOpen={isSearchFormOpen}
              searchButtonRef={this.searchButtonRef}
              searchValue={this.state.tempParams}
              onSearch={this.searchExecution}
              onOpen={this.toggleSearchForm}
              clearParams={this.handleClearParams}
              onChange={this.handleSearchParamsChange}
            />
            <div className='master-slide-view__body'>
              <table className='table table--notification-table NoticesTable'>
                <TableHeader />
                <tbody>
                  {_.map(this.state.dataList, (data, index) =>
                    this.renderNotificationRow(data, index)
                  )}
                </tbody>
                {!isLoading && _.isEmpty(dataList) && (
                  <tbody>
                    <tr>
                      <td>
                        <div className='table__message'>通知はありません</div>
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
              <InfinityScrollLoad
                targetId='infinityscroll-target'
                isLoading={isLoading}
                callback={notifyEnd => {
                  this.setNotifications(notifyEnd);
                }}
              />
              <Modal modalRoot='root' modalState={modalState}>
                {this.renderNotificationDetailModal()}
              </Modal>
              <TransmissionErrorResult
                fieldId={selectedNotice.field_id}
                checkInOutLogTransmissionHistoryId={selectedNotice.param1}
                isOpened={transmissionErrorResultDialogOpened}
                onClose={() => {
                  this.setState({
                    selectedNotice: {},
                    transmissionErrorResultDialogOpened: false,
                  });
                }}
              />
              <FieldsExpiredUsageModal
                visible={visibleFieldsExpiredUsageModal}
                onClose={this.toggleFieldsExpiredUsageModal}
                onConfirm={this.handleConfirmFieldExpiredUsage}
                onCancel={this.toggleFieldsExpiredUsageModal}
              />
              <UserAccessExpiredModal
                visible={visibleUserAccessExpiredModal}
                onClose={this.closeUserAccessExpiredModal}
              />
              <Information
                title='ユーザー稼働情報取得不可'
                visible={visibleNoUserAccessInfo}
                message={'ログインしたユーザの稼働状況を確認できませんでした。'}
                buttonText={messageUtility.getMessage('I-000-017')}
                onClose={this.closeNoUserAccessInfoDialog}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const TableHeader = () => {
  const HeaderCell = ({ children }) => {
    return (
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>{children}</div>
      </td>
    );
  };

  return (
    <thead className='table__header'>
      <tr className='table__label'>
        <HeaderCell>通知内容</HeaderCell>
      </tr>
    </thead>
  );
};

/**
 * @description 検索フォーム_テキスト
 * @param {string} placeholder プレースホルダー
 * @param {string} value
 * @param {function} handleOnChange
 */
const SearchFormTextInput = ({ placeholder, value, handleOnChange }) => (
  <input
    type='text'
    placeholder={placeholder}
    value={value}
    onChange={handleOnChange}
  />
);

/**
 * @description 検索フォームヘッダー
 * @param {function} onOpen 検索フォーム開閉処理
 * @param {boolean} isOpen true: オープン, false: クローズ
 * @param {number} total 取得通知件数
 * @param {function} clearParams 検索条件クリア処理
 */
const SearchFormHeader = ({ onOpen, isOpen, total, clearParams }) => (
  <div className='search-form__header'>
    <div className='search-form__title'>
      検索条件（検索結果
      <span className='bold'>{total}</span>
      件)
    </div>
    <button
      id='accordion-toggle'
      className={isOpen ? 'accordion__btn show' : 'accordion__btn'}
      onClick={onOpen}
    />
    <button type='button' className='btn-text--sm' onClick={clearParams}>
      検索条件クリア
    </button>
  </div>
);

/**
 * @description 検索フォーム コンポーネント
 */
const SearchForm = ({
  onOpen,
  isOpen,
  total,
  clearParams,
  onSearch,
  searchValue,
  searchButtonRef,
  onChange,
}) => (
  <div className='master-slide-view__searchform notices-search-form'>
    <div className='search-form'>
      <SearchFormHeader
        onOpen={onOpen}
        isOpen={isOpen}
        total={total}
        clearParams={clearParams}
      />
      <div
        id='search-form-accordion'
        className={isOpen ? 'accordion show' : 'accordion'}
      >
        <div className='search-form__body set-width-dropdown'>
          <div className='form form--search-form'>
            <div className='form__group flex-wrap'>
              <SearchFormElement
                label='現場名'
                eleClass='form-element__element --col-xs-12 --col-md-12 --col-lg-9 --col-xl-9'
              >
                <SearchFormTextInput
                  placeholder='現場名を入力'
                  value={_.get(searchValue, 'field_name', '')}
                  handleOnChange={e => onChange('field_name', e.target.value)}
                />
              </SearchFormElement>

              <SearchFormElement
                label='ステータス'
                eleClass='form-element__list'
              >
                <Stack className='form-list-radio form-list-default' direction='row' spacing='8px'>
                  {_.map(STATUS, status => (
                    <div key={status.VALUE}>
                      <label className='radio'>
                        <input
                          type='radio'
                          name='status'
                          value={status.VALUE}
                          id={`status-${status.VALUE}`}
                          checked={searchValue.status === status.VALUE}
                          onChange={e =>
                            onChange('status', _.toNumber(e.target.value))
                          }
                        />
                        <i className='i-2x' />
                        <span>{status.NAME}</span>
                      </label>
                    </div>
                  ))}
                </Stack>
              </SearchFormElement>

              <SearchFormElement label='種別' eleClass='form-element__list'>
                <DropdownSelector
                  label='種別を選択'
                  multiple={true}
                  options={LIST_NOTICES_TYPES}
                  valueName='id'
                  keyName='name'
                  onSelect={(name, values) => {
                    onChange('message_type_group_codes', values);
                  }}
                  selectedValues={searchValue.message_type_group_codes}
                />
              </SearchFormElement>

              <SearchFormElement eleClass='form-element__list'>
                <button
                  className='btn-fixedsize--stay search-form__btn--align-to-element'
                  onClick={onSearch}
                  ref={searchButtonRef}
                >
                  検索
                </button>
              </SearchFormElement>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/Notices.jsx